/**
 * API Configuration Utility
 * Handles dynamic API URL detection for devtunnels and production
 */

/**
 * Get API base URL with devtunnels support
 */
export function getAPIBaseURL() {
  // Check if we're accessing via devtunnels or other tunneling service
  const currentHost = window.location.hostname;
  const currentProtocol = window.location.protocol;

  // Development tunnel patterns
  const isDevTunnel = /.*\.devtunnels\.ms$/.test(currentHost) ||
                     /.*\.ngrok\.io$/.test(currentHost) ||
                     /.*\.ngrok-free\.app$/.test(currentHost) ||
                     /.*\.tunnel\.me$/.test(currentHost) ||
                     /.*\.localtunnel\.me$/.test(currentHost);

  if (isDevTunnel) {
    // For devtunnels, construct API tunnel URL

    // Check if API tunnel URL is provided via environment
    const devTunnelApiUrl = import.meta.env.VITE_DEVTUNNEL_API_URL;
    if (devTunnelApiUrl) {

      return devTunnelApiUrl;
    }

    // For VS Code DevTunnels, replace port in hostname
    // Pattern: 9l7qkwzl-5173.usw3.devtunnels.ms → 9l7qkwzl-5000.usw3.devtunnels.ms
    if (currentHost.includes('.devtunnels.ms')) {
      const apiHost = currentHost.replace(/-5173\./, '-5000.');
      const apiUrl = `${currentProtocol}//${apiHost}/api`;

      return apiUrl;
    }

    // For other tunnels, try the -api suffix pattern
    const apiHost = currentHost.replace(/^([^.]+)/, '$1-api');
    const apiUrl = `${currentProtocol}//${apiHost}/api`;

    return apiUrl;
  }

  // For localhost or production, use environment variable
  const envApiUrl = import.meta.env.VITE_API_URL;

  if (envApiUrl) {
    return envApiUrl;
  }

  // Fallback to localhost:5000/api

  return 'http://localhost:5000/api';
}

/**
 * Check if current environment is using devtunnels
 */
export function isDevTunnelEnvironment() {
  const currentHost = window.location.hostname;
  return /.*\.devtunnels\.ms$/.test(currentHost) ||
         /.*\.ngrok\.io$/.test(currentHost) ||
         /.*\.ngrok-free\.app$/.test(currentHost) ||
         /.*\.tunnel\.me$/.test(currentHost) ||
         /.*\.localtunnel\.me$/.test(currentHost);
}

/**
 * Get recommended API tunnel URL based on frontend tunnel
 */
export function getRecommendedAPITunnelURL() {
  const currentHost = window.location.hostname;
  const currentProtocol = window.location.protocol;

  if (isDevTunnelEnvironment()) {
    const apiHost = currentHost.replace(/^([^.]+)/, '$1-api');
    return `${currentProtocol}//${apiHost}/api`;
  }

  return null;
}